import {Subject} from 'rxjs';

export class ContextMenuView {
  show = false;
  menuItems: MenuItem [];
  mouseEvent: any; // tslint:disable-line

  constructor() { }
}

export class MenuItem {
  constructor(
    public icon: string,
    public label: string,
    public value: string,
    public action: string,
    public href: any, // tslint:disable-line
    public uuid?: string,
    public disabled?: boolean,
    public tooltip?: string,
    public subject?: Subject<MenuItem>,
    public hasPublication?: boolean
  ) { }
}
